export default "__VITE_PUBLIC_ASSET__16d81bed__"